import DineInMiniCartView from './dine-in-mini-cart-view'

export default DineInMiniCartView
